 <a class="green-link" [innerHTML]="content" (click)="handleClick($event)"></a>